'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ListTemplates = require('./ListTemplates.scss');

var _ListTemplates2 = _interopRequireDefault(_ListTemplates);

var _NewTemplate = require('../New/NewTemplate');

var _NewTemplate2 = _interopRequireDefault(_NewTemplate);

var _reactRedux = require('react-redux');

var _account = require('redux/modules/account');

var _email = require('redux/modules/email');

var _reduxConnect = require('redux-connect');

var _Allow = require('../../Allow/Allow');

var _Allow2 = _interopRequireDefault(_Allow);

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);

var _useBasename = require('../../../helpers/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListTemplates = (_dec = (0, _reduxConnect.asyncConnect)([{
    key: 'account',
    promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var state = getState();
        if (!state.account.data.reach) {
            return dispatch((0, _account.getAccount)());
        }
        return null;
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        account: state.account.data

    };
}, { getAccount: _account.getAccount, getTemplates: _email.getTemplates }), _dec(_class = _dec2(_class = function (_React$Component) {
    (0, _inherits3.default)(ListTemplates, _React$Component);

    function ListTemplates(props) {
        (0, _classCallCheck3.default)(this, ListTemplates);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ListTemplates.__proto__ || (0, _getPrototypeOf2.default)(ListTemplates)).call(this, props));

        _this.useTemplate = function (template) {
            if (_this.props.file) {
                template['properties']['subject'] = _this.props.draggedFileData.subject;
                _this.props.setDataToSend(template);
                _this.props.setTemplateId(template._id);
                _this.props.selectedComponent('Resumen');
            } else {
                _this.props.setDataToSend(template);
                _this.props.setTemplateId(template._id);
                _this.props.selectedComponent('Contactos');
            }
        };

        _this.renderTemplates = function () {
            return _this.state.templates.map(function (item, index) {
                return _react2.default.createElement(
                    'div',
                    { className: _ListTemplates2.default.existing },
                    !item.open ? _react2.default.createElement(
                        'div',
                        { className: _ListTemplates2.default.thumbnail, onClick: function onClick() {
                                _this.useTemplate(item);
                            } },
                        _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/previewMyTemplate.svg'), alt: '' })
                    ) : _react2.default.createElement(
                        'div',
                        { className: _ListTemplates2.default.actionContainer },
                        _react2.default.createElement(
                            _Allow2.default,
                            { permissions: ['channels:email:template:duplicate'] },
                            _react2.default.createElement(
                                'span',
                                { onClick: function onClick() {
                                        _this.setTemplateDuplicate(item);
                                    } },
                                'Duplicar'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'app' },
                            _react2.default.createElement(
                                'section',
                                { className: 'section' },
                                _react2.default.createElement(
                                    _Allow2.default,
                                    { permissions: ['channels:email:template:copyid'] },
                                    _react2.default.createElement(
                                        _reactCopyToClipboard2.default,
                                        { onCopy: function onCopy() {
                                                return _this.onCopy;
                                            }, text: _this.state.value },
                                        _react2.default.createElement(
                                            'span',
                                            null,
                                            'Copiar en el portapapeles'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _ListTemplates2.default.action },
                        _react2.default.createElement(
                            'div',
                            { className: item.open ? _ListTemplates2.default.nameHover : _ListTemplates2.default.name },
                            item.name
                        ),
                        _react2.default.createElement(
                            _Allow2.default,
                            { permissions: ['channels:email:template:duplicate'],
                                'else': _react2.default.createElement(
                                    _Allow2.default,
                                    {
                                        permissions: ['channels:email:template:copyid'] },
                                    _react2.default.createElement(
                                        'div',
                                        { className: _ListTemplates2.default.more, onClick: function onClick() {
                                                _this.moreAction(index, item._id);
                                            } },
                                        _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/moreTemplate.svg'), alt: '' })
                                    )
                                ) },
                            _react2.default.createElement(
                                'div',
                                { className: _ListTemplates2.default.more, onClick: function onClick() {
                                        _this.moreAction(index, item._id);
                                    } },
                                _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/moreTemplate.svg'), alt: '' })
                            )
                        )
                    )
                );
            });
        };

        _this.onCopy = function () {
            _this.setState({ copied: true });
        };

        _this.setTemplateDuplicate = function (template) {
            var data = template.properties;
            data['name'] = template.name;
            data['subject'] = template.subject;
            _this.setState({ componentRender: 'new', options: false, duplicate: template });
            _this.props.setCopied(true);
            _this.props.setDataToSend(data);
        };

        _this.moreAction = function (index, template) {
            _this.setState({ value: template });
            var copyTemplates = _this.state.templates;
            copyTemplates[index]['open'] = !_this.state.templates[index].open;
            _this.setState({ templates: copyTemplates });
        };

        _this.optionSelect = function (option) {
            _this.setState({ componentRender: option, options: false });
        };

        _this.selectLayout = function (name) {
            _this.setState({ layoutComponentSelected: name });
        };

        _this.changeStatusShowLayout = function () {
            _this.setState({ showLayout: !_this.state.showLayout });
        };

        _this.renderOptionsTemplates = function () {
            return _react2.default.createElement(
                'div',
                { className: _ListTemplates2.default.containerMyTemplates },
                _react2.default.createElement(
                    _Allow2.default,
                    { permissions: ['channels:email:template:create'] },
                    _react2.default.createElement(
                        'div',
                        { className: _ListTemplates2.default.new, onClick: function onClick() {
                                _this.props.setCopied(false);_this.optionSelect('new');
                            } },
                        _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/addTemplate.svg'), alt: 'nueva plantilla', className: _ListTemplates2.default.addIcon }),
                        _react2.default.createElement(
                            'span',
                            null,
                            'Crear plantilla'
                        )
                    )
                ),
                _this.renderTemplates()
            );
        };

        _this.state = {
            options: true,
            layouts: false,
            new: false,
            componentRender: 'options',
            components: ['options', 'layouts', 'new'],
            layoutComponentSelected: 'default',
            showLayout: false,
            account: _this.props.account,
            templates: [],
            duplicate: null,
            value: '',
            copied: false
        };

        return _this;
    }

    (0, _createClass3.default)(ListTemplates, [{
        key: 'componentDidMount',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var account_uid, templatesList, arrTemplates;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                account_uid = this.state.account._id;
                                _context.next = 3;
                                return this.props.getTemplates({ account_uid: account_uid });

                            case 3:
                                templatesList = _context.sent;
                                arrTemplates = templatesList.map(function (item) {
                                    var newItem = (0, _extends3.default)({}, item);
                                    newItem['open'] = false;
                                    return newItem;
                                });

                                this.setState({ templates: arrTemplates });

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function componentDidMount() {
                return _ref2.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { style: { float: 'left', height: '100%', width: '100%' } },
                this.state.componentRender === 'new' ? _react2.default.createElement(_NewTemplate2.default, {
                    showLayout: this.state.showLayout,
                    changeStatusShowLayout: this.changeStatusShowLayout,
                    selectLayout: this.selectLayout,
                    layoutSelected: this.state.layoutComponentSelected,
                    accountUI: this.props.accountUI,
                    completeComponentFunction: this.props.completeComponentFunction,
                    account_uid: this.props.account_uid,
                    setData: this.props.handleDataTwo,
                    setLayoutUid: this.props.setLayoutUid,
                    setDataToSend: this.props.setDataToSend,
                    duplicate: this.state.duplicate,
                    draggedFileData: this.props.draggedFileData
                }) : this.renderOptionsTemplates()
            );
        }
    }]);
    return ListTemplates;
}(_react2.default.Component)) || _class) || _class);
exports.default = ListTemplates;
module.exports = exports['default'];